<template>
  <div class="animated fadeIn">
    <el-dialog
      :modal="true"
      :center="true"
      title="PDF Preview"
      :visible.sync="pdfPreview"
      :before-close="hidePdfPreview"
      width="70%"
    >
      <iframe :src="pdfUrl" class="pdf-preview-frame"></iframe>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pdfPreview = false">Close</el-button>
      </span>
    </el-dialog>
    <b-row>
      <b-col lg="6">
        <b-card :header="'Profile ID: ' + generalId">
          <div
            v-if="(getName === '' && !editMode) || (getLogs.length === 0 && !editMode)"
            class="d-flex justify-content-center"
            style="margin-bottom:1em;"
          >
            <el-button
              @click="assignNameMode(true)"
            >{{ getName === ''?'Assign Name':'Adjust Name' }}</el-button>
          </div>
          <div class="d-flex justify-content-between">
            <h2>{{getName}}</h2>
            <h2>{{getCode}}</h2>
          </div>
          <hr />
          <h5>Demographics:</h5>

          <!-- Listing -->
          <el-row v-if="!editMode" v-for="id in reSortedSelectedDemo" :key="id.$index" :gutter="20">
            <el-col :span="8">
              <div class="grid-content text-right">{{getDemoNameById(id)}}:</div>
            </el-col>
            <el-col :span="16">
              <div class="grid-content">
                <b v-if="!editMode">{{getDemoUserDataById(id)}}</b>
              </div>
            </el-col>
          </el-row>

          <!-- Editor -->
          <el-row
            v-if="editMode"
            v-for="id in reOriginalSortedSelectedDemo"
            :key="id.$index"
            :gutter="20"
          >
            <el-col :span="8">
              <div class="grid-content text-right">{{getDemoNameById(id)}}:</div>
            </el-col>
            <el-col :span="16">
              <div class="grid-content">
                <el-input
                  :placeholder="'Please enter ' + getDemoNameById(id)"
                  v-model="editableFields[id]"
                ></el-input>
              </div>
            </el-col>
          </el-row>

          <hr v-if="editMode" />
          <el-checkbox
            v-if="editMode && editableFields[10] && editableFields[11] && editableFields[12]"
            v-model="sendEmail"
          >Send Email to Candidate</el-checkbox>
          <hr v-if="editMode && sendEmail" />
          <div v-if="editMode && sendEmail">
            <p>Customize the subject line and email for the message sent to the test-taker.</p>
          </div>
          <hr v-if="editMode && sendEmail" />
          <el-input
            v-if="editMode && sendEmail"
            :placeholder="'Please Enter a Subject Line'"
            v-model="emailSubjectLine"
          ></el-input>
          <el-input
            v-if="editMode && sendEmail"
            v-model="emailMessage"
            type="textarea"
            :autosize="{ minRows: 10, maxRows: 25}"
          ></el-input>
          <hr v-if="editMode" />
          <el-row v-if="editMode" :gutter="20">
            <el-col :span="24" class="d-flex justify-content-center">
              <el-button @click="saveCandidate(2)">
                Save
                {{ sendEmail ? '&amp; Send':''}}
              </el-button>
            </el-col>
          </el-row>
          <hr />
          <el-row :gutter="20">
            <el-col :span="12">
              <h5>State:</h5>
              <p v-if="getReports !== undefined && getReports.length > 0">Completed</p>
              <p
                v-if="getReports !== undefined && getReports.length === 0 && getLogs.length === 0"
              >Un-used</p>
              <p
                v-if="getReports !== undefined && getReports.length === 0 && getLogs.length > 0"
              >In-use</p>
            </el-col>
            <el-col :span="12">
              <h5>Package:</h5>
              <p>
                <router-link :to="'/packages/v/' + getPackageId">{{getPackageName}}</router-link>
              </p>
            </el-col>
          </el-row>
        </b-card>
        <b-card header="Reports">
          <div v-for="report in getReports" :key="report.$index">
            <el-divider
              content-position="left"
            >️{{(getTestNameById(report.test_id) !== undefined) ? getTestNameById(report.test_id).verbose_name : ''}}</el-divider>
            <el-row
              :gutter="20"
              v-for="(file, lang) in report.files"
              :key="lang"
              :class="lang%2?'bg-purple-light':''"
            >
              <el-col :span="6">{{ langMap[lang] }}</el-col>
              <el-col :span="6">
                <!-- https://pdf.aai-live.com/p/v/197061/490243/en/ -->
                <a
                  :href="'#preivew-' + report.id"
                  @click="showPdfPreview('https://pdf.aai-live.com/p/v/' + report.id + '/' + generalId + '/' + lang + '/')"
                >
                  <i class="el-icon-document"></i> Preview
                </a>
              </el-col>
              <el-col :span="6">
                <a
                  :href="'https://pdf.aai-live.com/p/d/' + report.id + '/' +generalId + '/' + lang + '/'"
                  target="_blank"
                >
                  <i class="el-icon-download"></i> Download
                </a>
              </el-col>
              <el-col :span="6">
                <a
                  :href="'https://pdf.aai-live.com/p/v/' + report.id + '/' + generalId + '/' + lang + '/'"
                  target="_blank"
                >
                  <i class="el-icon-tickets"></i> View
                </a>
              </el-col>
            </el-row>
            <br />
          </div>
        </b-card>
        <b-card header="Events">
          <el-collapse v-model="crmNotesTable" v-for="f in crmNotes" :key="f.$index">
            <el-collapse-item :title="f.date" :name="0">{{ f.message }}</el-collapse-item>
          </el-collapse>
        </b-card>
      </b-col>
      <b-col lg="6">
        <b-card header="Notes">
          <el-input
            v-model="notes"
            type="textarea"
            :autosize="{ minRows: 10, maxRows: 25}"
            @change="updateNotes(getCode, notes)"
          ></el-input>
        </b-card>
        <b-card header="Testing Log">
          <el-form>
            <el-form-item label="Reverse Log">
              <el-switch
                style="margin-top:.6em;"
                v-model="reverse"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </el-form-item>
          </el-form>
          <el-timeline :reverse="reverse">
            <el-timeline-item
              v-for="(activity, index) in getLogs"
              :key="index"
              :timestamp="formatDate(activity.date)"
            >{{activity.action_taken}}</el-timeline-item>
          </el-timeline>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import axios from '../../shared/axios';
import { LANGUAGE_MAP } from '../../data/languageNames.js';

export default {
  computed: {
    ...mapGetters('profile', [
      'getCode',
      'getName',
      'getReports',
      'getLogs',
      'getDemo',
      'getDemoSelected',
      'getDemoNameById',
      'getDemoUserDataById',
      'getNotes',
      'getPackageName',
      'getPackageId'
    ]),
    ...mapGetters('tests', ['getTestNameById']),
    ...mapGetters('auth', ['getCompanyName']),
    reSortedSelectedDemo() {
      const elements = [12, 11, 10];
      const obj2 = [];
      for (const inc in this.rawDemoData) {
        const newInc = inc.replace('demo_data_', '');
        obj2.push(parseInt(newInc, 10));
      }
      obj2.sort(function(a, b) {
        return a - b;
      });
      for (const inc in elements) {
        if (obj2.indexOf(elements[inc]) > -1) {
          const fName = obj2.splice(obj2.indexOf(elements[inc]), 1);
          obj2.unshift(elements[inc]);
        }
      }
      return obj2;
    },
    reOriginalSortedSelectedDemo() {
      const elements = [12, 11, 10];
      const obj = Object.assign([], this.getDemoSelected);
      obj.sort(function(a, b) {
        return a - b;
      });
      for (const inc in elements) {
        if (obj.indexOf(elements[inc]) > -1) {
          const fName = obj.splice(obj.indexOf(elements[inc]), 1);
          obj.unshift(elements[inc]);
        }
      }
      return obj;
    }
  },
  data: function() {
    return {
      editMode: false,
      notes: '',
      pdfPreview: false,
      pdfUrl: '',
      generalId: 0,
      reverse: false,
      activities: [],
      langMap: {
        ...LANGUAGE_MAP
      },
      activeReports: 0,
      marker: 0,
      crmNotes: [],
      crmNotesTable: 0,
      editableFields: {},
      sendEmail: false,
      emailSubjectLine: '',
      emailMessage: '',

      emailSubjectLineSource: '',
      emailMessageSource: '',
      rawDemoData: {}
    };
  },
  created() {
    const userId = this.$route.params.id;
    this.generalId = userId;
    const p = [];
    p.push(this.fetchUserProfile({ userId: userId }));
    p.push(this.fetchUserLogs({ userId: userId }));
    p.push(this.fetchDemoData({ userId: userId }));
    p.push(this.fetchTests());
    p.push(this.fetchCrmNotes());
    p.push(axios.get('settings/get'));

    Promise.all(p).then(r => {
      // console.log(r[3]);
      this.rawDemoData = r[2]['user'];
      // console.log(this.getNotes);
      this.notes = this.getNotes;
      for (const inc in this.getReports) {
        // console.log(this.getReports[inc]);
        this.activeReports = this.getReports[inc].test_id;
        break;
      }
      //
      console.log(r[5].data.rawSettings);
      this.emailSubjectLineSource = r[5].data.rawSettings.invite_subject_line;
      this.emailMessageSource = r[5].data.rawSettings.invite_message;
    });
  },
  watch: {
    editableFields: {
      handler: function(val, oldVal) {
        var vm = this;
        this.setDefaultMessage();
      }
    },
    deep: true
  },
  methods: {
    ...mapActions('profile', [
      'fetchUserProfile',
      'fetchUserLogs',
      'fetchDemoData'
    ]),
    ...mapActions('tests', ['fetchTests']),
    setDefaultMessage() {
      let tempSubject = this.emailSubjectLineSource;
      tempSubject = tempSubject.replace(
        /\[FirstName\]/gi,
        this.editableFields[10]
      );
      tempSubject = tempSubject.replace(
        /\[LastName\]/gi,
        this.editableFields[11]
      );
      tempSubject = tempSubject.replace(
        /\[Link\]/gi,
        'https://aai-live.com/?c=' + this.getCode
      );
      tempSubject = tempSubject.replace(/\[Code\]/gi, this.getCode);
      tempSubject = tempSubject.replace(/\[Company\]/gi, this.getCompanyName);
      tempSubject = tempSubject.replace(
        /\[UserEmail\]/gi,
        this.editableFields[12]
      );
      this.emailSubjectLine = tempSubject;

      let tempMessage = this.emailMessageSource;
      tempMessage = tempMessage.replace(
        /\[FirstName\]/gi,
        this.editableFields[10]
      );
      tempMessage = tempMessage.replace(
        /\[LastName\]/gi,
        this.editableFields[11]
      );
      tempMessage = tempMessage.replace(
        /\[Link\]/gi,
        'https://aai-live.com/?c=' + this.getCode
      );
      tempMessage = tempMessage.replace(/\[Code\]/gi, this.getCode);
      tempMessage = tempMessage.replace(/\[Company\]/gi, this.getCompanyName);
      tempMessage = tempMessage.replace(
        /\[UserEmail\]/gi,
        this.editableFields[12]
      );
      this.emailMessage = tempMessage;
    },
    formatDate(input) {
      return moment(input).format('M/D/YYYY h:mm a z');
    },
    showPdfPreview(s) {
      this.pdfPreview = true;
      this.pdfUrl = s;
    },
    hidePdfPreview() {
      this.pdfPreview = false;
      this.pdfUrl = '';
    },
    updateNotes(code, notes) {
      axios
        .post('/packages/notes/' + code + '/', { notes: notes })
        .then(r => {
          console.log(r);
          this.$message({
            message: 'Updated Notes',
            type: 'success'
          });
        })
        .catch(e => {
          console.error(e);
        });
    },
    fetchCrmNotes() {
      axios.get('/user/notes/' + this.generalId).then(r => {
        for (const i in r.data) {
          this.crmNotes.push({
            date: moment(r.data[i].date).format('LLLL'),
            message: r.data[i].notes.replace(/&quot;/gi, '"'),
            index: i
          });
        }
      });
    },
    assignNameMode(m) {
      this.editMode = m;
    },
    saveCandidate(m) {
      console.log(m);
      axios
        .post('/user/profile', {
          mode: parseInt(m, 10),
          id: this.generalId,
          demo: this.editableFields,
          sendEmail: this.sendEmail,
          emailSubjectLine: this.emailSubjectLine,
          emailMessage: this.emailMessage
        })
        .then(r => {
          console.log(r);
          this.$router.go();
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>
<style>
.el-range-separator {
  width: 10% !important;
}
.pdf-preview-frame {
  width: 100%;
  height: 65vh;
}
</style>